"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listProducts = void 0;
const products_1 = require("@/store/ducks/products");
const products_2 = require("@/services/products");
function listProducts() {
    return (dispatch) => {
        dispatch((0, products_1.getProductsList)());
        (0, products_2.getProducts)()
            .then((products) => {
            const productRows = products.map((product) => {
                return {
                    id: product.id,
                    name: product.name,
                    updatedAt: defineUpdateDate(product),
                    deletable: true,
                };
            });
            dispatch((0, products_1.getProductsListSuccess)(productRows));
        })
            .catch(() => {
            dispatch((0, products_1.getProductsListError)());
        });
    };
}
exports.listProducts = listProducts;
const defineUpdateDate = (product) => {
    if (product.createdAt && !product.updatedAt) {
        return product.createdAt;
    }
    if (product.createdAt && product.updatedAt) {
        return product.updatedAt;
    }
    return "-";
};
exports.default = {
    listProducts,
};
